export default __webpack_public_path__ + "static/blob1-20e382e95f085a7b0a30d63028e80ad4.svg";